import styled from '@emotion/styled';
import { Box } from '@mafc/trolly';

export const RRWrapper = styled(Box)`
  .prev-button svg {
    ${(props: any) => (props.isRTL ? 'right: 1px' : '')};
  }
  .next-button svg {
    ${(props: any) => (props.isRTL ? 'right: -1px' : '')};
  }
`;
